import React from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';

const SkeletonCard = ({ variant = 'wallet' }) => {
  if (variant === 'total') {
    return (
      <div className="skeleton-loader">
        <ContentLoader
          viewBox="0 0 350 240"
          height={200}
          width="100%"
        >
          <rect x="0" y="10" width="100" height="12" rx="4" />
          <rect x="250" y="10" width="70" height="12" rx="4" />
          <rect x="100" y="110" width="150" height="40" rx="6" />
          <rect x="0" y="210" width="120" height="10" rx="4" />
          <rect x="250" y="210" width="70" height="10" rx="4" />
        </ContentLoader>
      </div>
    );
  }

  return (
    <div className="skeleton-loader">
      <ContentLoader viewBox="0 0 350 90" height={80} width="100%">
        <circle cx="20" cy="20" r="15" />
        <rect x="45" y="13" width="80" height="12" rx="4" />
        <rect x="0" y="45" width="100" height="16" rx="4" />
        <rect x="0" y="70" width="120" height="10" rx="4" />
        <rect x="260" y="13" width="70" height="10" rx="4" />
        <rect x="260" y="70" width="70" height="10" rx="4" />
      </ContentLoader>
    </div>
  );
};

SkeletonCard.propTypes = {
  variant: PropTypes.oneOf(['wallet', 'total']),
};

SkeletonCard.defaultProps = {
  variant: 'wallet',
};

export default SkeletonCard;
